/**
 * @typedef {Object} EgdCarouselSlide
 * @property {string|number} [id] - Payload document id
 * @property {string} [key]
 * @property {string} title
 * @property {string} [description]
 * @property {string} [image] - CDN-relative foreground path
 * @property {string} [bg_image] - CDN-relative background path
 * @property {string} [image_alt]
 * @property {string} [button_link]
 * @property {string} [button_text]
 * @property {string} [button_disabled] - `"true"` when CTA is disabled
 * @property {string} [description_bg_color]
 * @property {string} [publish_at]
 * @property {string} [unpublish_at]
 */

/**
 * Maps a Payload `egd-carousel` document to the legacy ERS slide shape
 * consumed by HeroCarousel and shouldPublish().
 *
 * @param {Record<string, unknown>} doc - Payload REST document
 * @param {string} [_locale]
 * @returns {EgdCarouselSlide}
 */
export function mapEgdCarouselSlide(doc, _locale) {
  return {
    id: doc.id != null ? doc.id : undefined,
    key: doc.key || undefined,
    title: doc.title,
    description: doc.description || undefined,
    image: doc.image || undefined,
    bg_image: doc.bgImage || undefined,
    image_alt: doc.imageAlt || undefined,
    button_link: doc.buttonLink || undefined,
    button_text: doc.buttonText || undefined,
    button_disabled: doc.buttonDisabled === true ? "true" : undefined,
    description_bg_color: doc.descriptionBgColor || undefined,
    publish_at: doc.publishAt || undefined,
    unpublish_at: doc.unpublishAt || undefined,
  };
}

/**
 * @param {{ docs?: unknown[] }} payloadResponse
 * @param {string} [locale]
 * @returns {EgdCarouselSlide[]}
 */
export function mapEgdCarouselResponse(payloadResponse, locale) {
  const docs = Array.isArray(payloadResponse?.docs) ? payloadResponse.docs : [];
  return docs.map((doc) => mapEgdCarouselSlide(doc, locale));
}
